module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<legend>'+
((__t=( legendText ))==null?'':_.escape(__t))+
'</legend>\n\n<select class="bankaccount grid4" '+
((__t=( disableToggle ))==null?'':_.escape(__t))+
'></select>\n<p>'+
((__t=( settlementWarning ))==null?'':__t)+
'</p>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./epayment_import/templates/account.html
// module id = 208
// module chunks = 0